import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Stack } from 'shared/mui/Stack/Stack';

import {
  CardHeaderStyled,
  CardStyled,
  TooltipWithInfoIconStyled,
} from './OrdersShowNotifications.styled';
import { OrdersShowNotificationsCreate } from './OrdersShowNotificationsCreate';
import { OrdersShowNotificationsList } from './OrdersShowNotificationsList';

export const OrdersShowNotifications: React.FC = () => {
  const { hasResourceAccess } = usePermissions();
  const translate = useTypedTranslate();

  return (
    <Stack gap={2}>
      <CardStyled>
        <CardHeaderStyled
          title={translate('app.orders.notifications.title')}
          titleSize="smallBold"
        />
        {hasResourceAccess('order_notifications') && <OrdersShowNotificationsList />}
      </CardStyled>
      <CardStyled>
        <CardHeaderStyled
          title={
            <>
              {translate('app.orders.notifications.sendNotification')}{' '}
              <TooltipWithInfoIconStyled
                iconSize={24}
                placement="right"
                tooltipText={translate('app.orders.notifications.tooltipText')}
              />
            </>
          }
          titleSize="smallBold"
        />
        <OrdersShowNotificationsCreate />
      </CardStyled>
    </Stack>
  );
};
